import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { SendEmailForConsultationMutationResponse, SendEmailForConsultation400, SendEmailForConsultation401, SendEmailForConsultation403, SendEmailForConsultation404, SendEmailForConsultation410, SendEmailForConsultation422, SendEmailForConsultation429, SendEmailForConsultation500 } from "../types/SendEmailForConsultation";

/**
 * @link /api/credit-flow-backend/private/v1/consultation/do_create-request
 */

export function useSendEmailForConsultation <TData = SendEmailForConsultationMutationResponse, TError = SendEmailForConsultation400 | SendEmailForConsultation401 | SendEmailForConsultation403 | SendEmailForConsultation404 | SendEmailForConsultation410 | SendEmailForConsultation422 | SendEmailForConsultation429 | SendEmailForConsultation500>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, void>,
          client?: Partial<Parameters<typeof client<TData, TError, void>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, void> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, void>({
    mutationFn: () => {
      
      return client<TData, TError, void>({
        method: "post",
        url: `/api/credit-flow-backend/private/v1/consultation/do_create-request`,
        
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
